import React, { useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

import Input from '../../components/FloatInput';
import Button from '../../components/Button';
import Form from '../../components/Form';
import { showNotification, ERROR_TYPE } from '../../components/Notification';

import styles from './styles.module.scss';
import { LAYOUT_0_24, VALIDATE_MESSAGES } from '../../constants/form';
import { emailValidator } from '../../helpers/validators';
import { useDispatch } from 'react-redux';
import { loginWealthie } from '../../store/reducers/authSlice';

function LoginPage(): React.ReactElement {
  const dispath = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();

  const onFinish = useCallback(
    async (values) => {
      dispath(loginWealthie(values.email, values.password, history));
    },
    [history, dispath],
  );

  const onFinishFailed = useCallback(() => {
    showNotification({
      type: ERROR_TYPE,
      message: 'Please fill in proper form values.',
    });
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.content_wrapper}>
        <div className={styles.login_wrapper}>
          <h1>Admin Login</h1>
          <Form
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            form={form}
            validateMessages={VALIDATE_MESSAGES}
            {...LAYOUT_0_24}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, validator: emailValidator }]}
            >
              <Input
                inputId="email-input-id"
                type="Text"
                label="Your Email Address"
                inputProps={{ value: form.getFieldValue('email') }}
              />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true }]}
            >
              <Input
                inputId="2"
                type="Password"
                inputProps={{ value: form.getFieldValue('password') }}
                label="Password"
              />
            </Form.Item>
            <Form.Item
              shouldUpdate
              className={`${styles.button_container} ${styles.center_login_section}`}
            >
              <Button htmlType="submit">LOG IN</Button>
            </Form.Item>
          </Form>

          <div className={styles.misc}>
            <Link to="/forgot-pwd" className={styles.link}>
              Forgot password?
            </Link>
          </div>

          <div className={styles.divider} />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
